<nav class="navbar navbar-expand-lg navbar-light bg-light" *ngIf="auth.isLoggedIn()">
  <div class="collapse navbar-collapse">
    <ul class="navbar-nav mr-auto">
    </ul>
  </div>
</nav>
<router-outlet></router-outlet>
